import { createTheme } from "@mui/material/styles"
import { color } from "./utilities"

const theme = createTheme({
  palette: {
    primary: {
      main: color.blue,
      contrastText: color.white,
    },
    secondary: {
      main: color.yellow,
      contrastText: color.white,
    },
    error: {
      main: color.red,
      contrastText: color.white,
    },
    warning: {
      main: color.yellow,
      contrastText: color.white,
    },
    info: {
      main: color.link,
      contrastText: color.white,
    },
    success: {
      main: color.green,
      contrastText: color.white,
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: color.blue },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          // We need this comment - inputs are probably gonna be styled
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: color.gray,
          color: color.sand,
          maxWidth: "200px",
          textAlign: "center",
          padding: "10px",
        },
        arrow: {
          color: color.gray,
        },
      },
    },
  },
})

export default theme
